import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=f308512e&scoped=true&"
import script from "./ModalAlert.vue?vue&type=script&lang=js&"
export * from "./ModalAlert.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlert.vue?vue&type=style&index=0&id=f308512e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f308512e",
  null
  
)

export default component.exports